import type { ArenaBox, ArenaDefinition } from './arena.ts';

export const BARRICADE = { width: 3.2, depth: 0.65, height: 1.45, hp: 6, ticks: 600, reach: 2.1 } as const;
export interface BarricadeShape { x:number; y:number; z:number; alongX:boolean }
export function barricadeBox(b:BarricadeShape, id='barricade'):ArenaBox {
  const x=(b.alongX?BARRICADE.width:BARRICADE.depth)/2;
  const z=(b.alongX?BARRICADE.depth:BARRICADE.width)/2;
  return {id,kind:'wall',min:{x:b.x-x,y:b.y,z:b.z-z},max:{x:b.x+x,y:b.y+BARRICADE.height,z:b.z+z}};
}
/** Same temporary collision geometry on the server and in movement prediction. */
export function withBarricades(arena:ArenaDefinition, barricades:Iterable<BarricadeShape>):ArenaDefinition {
  const boxes=[...barricades].map((b,i)=>barricadeBox(b,`barricade:${i}`));
  return boxes.length?{...arena,solids:[...arena.solids,...boxes]}:arena;
}
